<template>
  <section class="c-section c-section--about">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card class="p-0">
            <div class="container-fluid p-0">
              <div style="height:400px">
                <div class="w-100 d-flex justify-content-center">
                  <b-skeleton-img no-aspect width="100%" height="300px"></b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <b-row>
                <b-col cols="6">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="400px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img no-aspect height="400px"></b-skeleton-img>
                </b-col>
              </b-row>

              <b-row >
                <b-col cols="3">
                  <b-skeleton-img no-aspect height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="3">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
                <b-col cols="6">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
              </b-row>
            </div>
          </b-card>
      </template>
      <div v-if="context.banner" class="c-banner-top">
        <img :src="context.banner.fondo" alt="" class="c-banner-top__background">
        <div class="c-banner-top__gradient"></div>
        <div class="container position-relative h-100">
          <figure class="c-banner-top__semiluna">
            <img
              src="@/assets/images/semiluna.png"
              alt=""
              class="w-100 of--contain d-none d-md-block"
            >
          </figure>
          <div class="c-banner-top__contain">
            <div data-aos="fade-up">
              <h2 class="white fs-50 w-black mb-0">
                {{context.post.post_title}}
              </h2>
              <div class="d-flex">
                <router-link to="" class="c-banner-top__link">
                  Inicio
                </router-link>
                <span class="mx-1 white fs-16 w-medium">/</span>
                <p class="white fs-16 w-medium mb-0">
                  {{context.post.post_title}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.informacion" class="c-solutions">
        <div class="container">
          <div class="row gy-5">
            <div data-aos="fade-right" class="col-12 col-lg-6">
              <h2 class="sec-light fs-16 w-sbold mb-2">
                {{context.informacion.subtitulo}}
              </h2>
              <h2 v-html="titulos.information" class="c-solutions__title mb-5">
              </h2>
              <div
                v-html="content.information"
                class="sec-light fs-16 w-medium line-height mb-0">
              </div>
            </div>
            <div data-aos="fade-left" class="col-12 col-lg-6">
              <div class="row gy-4">
                <template v-for="(item,i) of context.informacion.galeria.slice(0,2)">
                  <div
                    :key="`item-${i}`"
                    class="col-12" :class="{'col-md-6' : i < 2}">
                    <figure :class="position(i)">
                      <img :src="item.imagen" alt="" class="w-100 h-100 of--cover">
                    </figure>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.estadisticas" class="c-statistics py-5">
        <div class="container">
          <div class="row gy-4 justify-content-center text-center text-lg-start">
            <div
              v-for="(item,i) of context.estadisticas"
              :key="`item-${i}`"
              data-aos="fade-up"
              :data-aos-delay="100 * (i + 1)"
              class="col-6 col-md-4 col-lg-3">
              <h2 class="white fs-40 w-black">
                {{item.numero}}+
              </h2>
              <p class="white fs-18 w-medium line-height mb-0">
                {{item.label}}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="context.informacion" class="c-values py-5">
        <div class="container">
          <div class="row gy-5">
            <div data-aos="fade-up"
              class="col-12 col-lg-4">
              <div
                class="
                c-values__data d-flex align-items-center justify-content-center flex-column">
                <div class="c-values__icon mb-3">
                  <Icon icon="tabler:speakerphone"/>
                </div>
                <h3 class="c-values__title mb-3">Misión</h3>
                <p class="c-values__text">
                  {{context.informacion.mision}}
                </p>
              </div>
            </div>
            <div data-aos="fade-up"
               class="col-12 col-lg-4">
              <div class="c-values__figure">
                <img :src="context.informacion.seccion_vision_imagenes.primera_imagen"
                class="w-100 h-100" alt="">
              </div>
            </div>
            <div data-aos="fade-left"
              class="col-12 col-lg-4">
              <div
                class="
                c-values__data d-flex align-items-center justify-content-center flex-column">
                <div class="c-values__icon mb-3">
                  <Icon icon="material-symbols:target"/>
                </div>
                <h3 class="c-values__title mb-3">Visión</h3>
                <p class="c-values__text">
                  {{context.informacion.vision}}
                </p>
              </div>
            </div>
            <div data-aos="fade-left"
              class="col-12 col-lg-4">
              <div class="c-values__figure">
                <img :src="context.informacion.seccion_vision_imagenes.segunda_imagen"
                class="w-100 h-100" alt="">
              </div>
            </div>
            <div data-aos="fade-up"
              class="col-12 col-lg-4">
              <div
                class="
                c-values__data d-flex align-items-center justify-content-center flex-column">
                <div class="c-values__icon mb-3">
                  <Icon icon="material-symbols:saved-search-rounded"/>
                </div>
                <h3 class="c-values__title mb-3">Valores</h3>
                <ul v-if="context.informacion.valores" class="c-values__list">
                  <li v-for="(valor,i) of context.informacion.valores" :key="`valor-${i}`">
                    {{valor.valor}}
                  </li>
                </ul>
              </div>
            </div>
            <div data-aos="fade-right"
              class="col-12 col-lg-4">
              <div class="c-values__figure">
                <img :src="context.informacion.seccion_vision_imagenes.tercera_imagen"
                class="w-100 h-100" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="context.testimonios">
        <div class="c-testimonials" :class="{'d-none' : !context.testimonios.lista}">
          <div class="container">
            <div class="row justify-content-center">
              <div data-aos="fade-up" class="col-10 col-md-8 col-lg-6">
                <h2 class="text-center sec-alt fs-16 w-sbold line-height mb-3">
                  {{context.testimonios.subtitulo}}
                </h2>
                <h2 v-html="titulos.testimonios" class="c-testimonials__title mb-5">
                </h2>
              </div>
            </div>
            <div id="slider-testimony" class="c-slider-testimony swiper">
              <div class="swiper-wrapper position-relative">
                <div
                  v-for="(item,i) of context.testimonios.lista"
                  :key="`item-${i}`"
                  class="swiper-slide h-100">
                  <div
                    data-aos="fade-up"
                    :data-aos-delay="100 * (i + 1)"
                    class="c-testimony"
                  >
                    <div class="d-flex gap-3 mb-3">
                      <div>
                        <figure class="c-testimony__avatar">
                          <img :src="item.icono" alt="" class="w-100 h-100 of--cover">
                        </figure>
                      </div>
                      <div class="h-100">
                        <h2 class="sec-color fs-18 w-xbold">
                          {{item.nombre}}
                        </h2>
                        <h2 class="sec-alt fs-14 w-bold mb-0">
                          {{item.puesto}}
                        </h2>
                      </div>
                    </div>
                    <p class="sec-alt fs-16 w-regular line-height mb-0">
                      {{item.comentario}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination mt-4" cursor="pointer"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="context.portafolio" class="c-briefcase">
        <div class="container">
          <div class="row justify-content-center">
            <div data-aos="fade-up" class="col-10 col-md-8 col-lg-6">
              <h2 class="text-center sec-alt fs-16 w-sbold line-height mb-3">
                Portafolio_
              </h2>
              <h2 class="c-briefcase__title mb-5">
                Nuestro propósito es la <strong>excelencia</strong>
              </h2>
            </div>
          </div>
          <div class="row gy-4 justify-content-center">
            <div
              v-for="(item,i) of context.portafolio.lista"
              :key="`item-${i}`"
              data-aos="fade-up"
              :data-aos-delay="100 * (i + 1)"
              class="col-12 col-md-6 col-lg-3">
              <a :href="`/portafolio/${item.link.post_name}`" class="h-100 d-flex flex-column">
                <div class="c-briefcase__logo">
                  <img :src="item.imagen" alt="" class="c-briefcase__img">
                </div>
                <div class="c-briefcase__title-card d-flex">
                  <h2>
                    {{item.nombre}}
                  </h2>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
import {
  Swiper,
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper';

export default {
  data() {
    return {
      sliderTestimony: null,
      context: {},
      contextLoading: true,
      titulos: {
        information: '',
        testimonios: '',
        portafolio: '',
      },
      content: {
        information: '',
      },
    };
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'nosotros' });
  },
  mounted() {
  },
  watch: {
    contextLoading(state) {
      if (!state) {
        this.initTestimonySlider();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.context.post.content;
        this.titulos.information = tempDiv.getElementsByTagName('h2')[0].innerHTML;
        this.titulos.testimonios = tempDiv.getElementsByTagName('h2')[1].innerHTML;
        this.titulos.portafolio = tempDiv.getElementsByTagName('h2')[2].innerHTML;
        tempDiv.querySelectorAll('h2').forEach((element) => element.remove());
        this.content.information = tempDiv.innerHTML;
        console.log(this.content.information, 'sadsss');
      }
    },
  },
  methods: {
    initTestimonySlider() {
      window.setTimeout(() => {
        this.sliderTestimony = new Swiper('#slider-testimony', {
          modules: [Navigation, Pagination, Autoplay],
          autoHeight: true,
          speed: 1500,
          // loop: true,
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 25,
            },
            720: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 25,
            },
          },

          pagination: {
            el: '#slider-testimony .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },

          navigation: {
            prevEl: '#slider-testimony-prev',
            nextEl: '#slider-testimony-next',
          },
        });
      }, 100);
    },
    position(i) {
      return {
        'c-solutions__left': i === 0,
        'c-solutions__right': i === 1,
        'c-solutions__large': i === 2,
      };
    },
  },
};
</script>
